import { render } from "./NewList.vue?vue&type=template&id=015cc880&scoped=true"
import script from "./NewList.vue?vue&type=script&lang=js"
export * from "./NewList.vue?vue&type=script&lang=js"

import "./NewList.vue?vue&type=style&index=0&id=015cc880&scoped=scoped&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015cc880"]])

export default __exports__